// #region Imports
/**
 * To use react related functionality
 */
import React from 'react';
/**
 * To use Spinner component
 */
import Spinner from './Spinner';
// #endregion
// Create a wrapper that replaces a component with a spinner
// if it has a loading prop set to true.
//The function takes two arguments, which are the spinnerProps object and the WrappedComponent component.
const withLoading = spinnerProps => WrappedComponent => {
    //t creates a new component called LoadingComponent
    const LoadingComponent = props => {
        //if props loading  property is true then return Spinner
        if (props.loading) {
            return <Spinner {...spinnerProps} />;
        }
        // //if props loading  property is false
        return <WrappedComponent {...props} />;
    };
    //return component
    return LoadingComponent;
};

export default withLoading;